<template>
    <div id="navbar">
        <router-link to="/">
            <div id="logo">
                <img id="top" :src="require('@/assets/MMoose (40px).png')"/>
                <div id="logoName">Moose</div>
            </div>
        </router-link>
        <!-- <span class="nav-title is-hidden-touch">{{$route.name}}</span> -->
        <nav>
            <router-link to="/">
                    <font-awesome-icon :icon="['fal', 'home']" size='lg'/>
            </router-link>
            <router-link to="/about" >
                    <font-awesome-icon :icon="['fal', 'user']" size='lg' />
            </router-link>
            <router-link to="/projects">
                    <font-awesome-icon :icon="['fal', 'cog']" size='lg'/>
            </router-link>
            <router-link to="/contact">
                    <font-awesome-icon :icon="['fal', 'envelope']" size='lg'/>
            </router-link>
            <!-- <router-link to="/" @mouseenter.native="home=true" @mouseleave.native="home=false" @touchstart.capture.prevent="home=true; $router.push('/')">
                <transition name="fade" mode="out-in">
                    <font-awesome-icon v-if="home == false" :icon="['fal', 'home']" size='lg' key='icon'/>
                    <span v-else class="iconText" key="text">Home</span>
                </transition>
            </router-link>
            <router-link to="/about" @mouseenter.native="about=true" @mouseleave.native="about=false" @touchstart.capture.prevent="about=true; $router.push('/about')">
                <transition name="fade" mode="out-in">
                    <font-awesome-icon v-if="about == false" :icon="['fal', 'user']" size='lg' key='icon'/>
                    <span v-else class="iconText" key="text">About</span>
                </transition>
            </router-link>
            <router-link to="/projects" @mouseenter.native="projects=true" @mouseleave.native="projects=false" @touchstart.capture.prevent="projects=true; $router.push('/projects')">
                <transition name="fade" mode="out-in">
                    <font-awesome-icon v-if="projects == false" :icon="['fal', 'cog']" size='lg' key='icon'/>
                    <span v-else class="iconText" key="text">Projects</span>
                </transition>
            </router-link>
            <router-link to="/contact" @mouseenter.native="contact=true" @mouseleave.native="contact=false" @touchstart.capture.prevent="contact=true; $router.push('/contact')">
                <transition name="fade" mode="out-in">
                    <font-awesome-icon v-if="contact == false" :icon="['fal', 'envelope']" size='lg' key='icon'/>
                    <span v-else class="iconText" key="text">Contact</span>
                </transition>
            </router-link> -->
        </nav>
    </div>
</template>

<script>
export default {
  mounted () {
    this.listener = (e) => {
      if (!document.getElementsByClassName('router-link-exact-active')[0].contains(e.target)) {
        this.home = false
        this.about = false
        this.contact = false
        this.projects = false
      };
    }
    setTimeout(() => {
      document.addEventListener('touchstart', this.listener)
    })
  },
  beforeDestroy () {
    document.removeEventListener('touchstart', this.listener)
  },
  data: function () {
    return {
      home: false,
      about: false,
      contact: false,
      projects: false
    }
  },
  methods: {
    mouseEnter: function (type) {
      this.about = true
      console.log(type)
    }
  }
}
</script>

<style scoped>
#top{
    padding: 3px 0px;
    margin: auto;
    display: block;
    width: 40px;
    height: 40px;
}
#logoName{
    color:white;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
nav > a{
    line-height: 51px;
    height: 51px;
}
.iconText{
    font-size: .75em;
}
#navbar{
    background-color: #181818;
}
#logo{
    margin-bottom: auto;
    height: 60px;
    width: 60px;
    background-color: black;
}
#logoName{
    line-height: 1;
    font-size: .75em;
}
.router-link-exact-active * {
    color: cyan;
 }
a, a:visited, a:focus, a:active{
    text-decoration: none;
    color:rgb(151, 151, 151);
    width: 60px;
    display: block;
}
.nav-title{
    font-size: 2rem;
    color: white;
    line-height: 3.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/NavigationBar.vue